const initialState = {
    recentlyViewedClients: []
};

export default function entitySearch(state = initialState, action = {}) {
    switch (action.type) {
        case 'ACTIVE_CLIENT_LOAD_SUCCESS':

            var client = action.result;
            var entityName = client.name;
            var oldRecentlyViewedClients = JSON.parse(localStorage.getItem('recentlyViewedClients')) || [];



            var latestClient = {
                ...client,
                clientId: client.id,
                entityType: 'company',
                entityName
            };

            var recentlyViewedClients = [latestClient].concat(
                oldRecentlyViewedClients.filter(e => e.id != client.id).slice(0, 11)
            );

            localStorage.setItem('recentlyViewedClients', JSON.stringify(recentlyViewedClients));

            return {
                ...state,
                recentlyViewedClients
            };
        case 'LOAD_RECENTLY_VEIWED_CLIENTS':
            return {
                ...state,
                recentlyViewedClients: action.recentlyViewedClients
            };
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./app/reducers/entitySearch.js